// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"529":"d067e0fd","602":"3d14fb91","659":"8d564fa3","698":"5797b609","916":"2b306930"}[chunkId] + ".chunk.css";
};